import {useLocation, useNavigate } from 'react-router-dom';

export default function withRouter(Children){ 
    return(props)=>{
      const match  = {paramsLocation: useLocation()};
      const navegar = useNavigate();
      return <Children {...props}  match = {match} navegar = {navegar}/>
   }
 }